import type { JsonObject } from '@seen/core/json'
import { saveBlobWithName } from '@seen/core/utils'

const CCDA_VIEWER_URL = 'https://ccda.medplum.com'

export function sendCommand(
  iframe: HTMLIFrameElement,
  command: JsonObject
): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!iframe.contentWindow) {
      reject(new Error('Iframe content window not available'))
      return
    }

    iframe.contentWindow.postMessage(command, CCDA_VIEWER_URL)
    resolve()
  })
}

export function exportJsonFile(json: string, filename: string): void {
  const blob = new Blob([json], {
    type: 'application/json',
  })
  saveBlobWithName(blob, `${filename}.json`)
}
